/**
 * Lazy registration for `<e-diagram>` (+ `<e-diagram-node|edge|scene>`).
 *
 * The diagram element pulls Mermaid (~heavy) — but only when an instance
 * actually RENDERS (the element imports mermaid lazily itself). Even so the
 * `@econnect/ui-diagram/define` chunk is dead weight on the ~99% of pages that
 * render no diagram, so gate the define on a `<e-diagram>` being present in the
 * DOM. A single `defineDiagram()` registers all four tags.
 *
 * `ensureDiagramDefine` is a global idempotent latch (custom-element
 * registrations are permanent). A DOM-presence miss does NOT set the latch, so
 * a later navigation to a diagram page retries. Called from the WC loader's
 * idle/nav presence sweep AND from the DiagramBlock's own `onMounted` (which
 * defeats the `<ClientOnly>` mount race the loader's DOM poll can lose).
 */
let diagramLoaded = false;

export async function ensureDiagramDefine(): Promise<void> {
  if (diagramLoaded) return;
  if (!document.querySelector("e-diagram")) return;
  diagramLoaded = true;
  const { defineDiagram } = await import("@econnect/ui-diagram/define");
  defineDiagram();
}
